import { gql } from '@apollo/client';

/**
 * The company name in the profile menu.
 *
 * Its own small query rather than the company settings one, which fetches the
 * whole record including the logo — the menu wants a name. Looked up by uuid
 * because that is what the Auth0 `company` claim carries.
 */
export const COMPANY_NAME = gql`
  query MenuBarCompanyName($uuid: ID!) {
    distributorByUuid(uuid: $uuid) {
      id
      name
    }
  }
`;
